import styled from 'styled-components'

import { helpers } from 'styles'

export const FloatingGroup = styled.div`
	display: none;

	@media only screen and (max-width: 750px) {
		display: block;
		position: absolute;
		z-index: 98;
		right: 32px;
		bottom: 32px;
		background-color: ${helpers.color.secondary};
		border-radius: 4px;
		padding: 8px;

		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}
`
